export default "__VITE_ASSET__8abb6298__"